<app-navbar></app-navbar>
<router-outlet />
<app-footer></app-footer>
@if (editHide) {
  <edit-side-menu
    class="edit-nav"
    (editEvent)="editMenuToggle($event)"
    [ngClass]="{ show: editHide, hide: !editHide }"
    appCloseSideMenu
  ></edit-side-menu>
}
